import React from 'react';
import Answer from '../../../components/answer/index.js';
import Score from '../../../components/score';
import Breadcrumbs from '../../../components/breadcrumbs';

const Step = (props)=> {
  return (
	<div className="screen">
		<form className="actView fadeIn" onSubmit={props.formHandler}>
			<div className="question">
				<h3 className="header3">01</h3>
				<h5 className="header5">In the <u>past 4 weeks</u>, how much of the time did your <u>asthma</u> keep you from getting as much done at work, school or at home?</h5>
				<div className="columns">
					<div className="column">
						<Answer handler={props.answerHandler} id={props.name+"0"} set={props.name} value="1" state={props.state}>All of the time</Answer>
						<Answer handler={props.answerHandler} id={props.name+"1"} set={props.name} value="2" state={props.state}>Most of the time</Answer>
						<Answer handler={props.answerHandler} id={props.name+"2"} set={props.name} value="3" state={props.state}>Some of the time</Answer>
					</div>
					<div className="column">		
						<Answer handler={props.answerHandler} id={props.name+"3"} set={props.name} value="4" state={props.state}>A little of the time</Answer>
						<Answer handler={props.answerHandler} id={props.name+"4"} set={props.name} value="5" state={props.state}>None of the time</Answer>
					</div>
				</div>
			</div>
			<button className="prev" type="button" onClick={props.prevHandler}>Back</button>
			<button className="next" type="submit" disabled>Next</button>
		</form>
		<Score Score={props.TempScore} Results={false} role={props.role} />
		<Breadcrumbs Step={props.step} Steps={props.steps-1} />
	</div>
  );
}

export default Step;
